import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Text, TextLink } from '@machobear/design-system'
import { colors } from '@/styles'
import config from '@/config'
import EmptyImage from './empty-image'

type Props = {
  text: string
  currentListingTab: string
}

const { APP_PATH } = config

const ListingsEmptyListComponent: React.FC<Props> = ({ text, currentListingTab }) => {
  const { t } = useTranslation()
  const isIntegration = currentListingTab === 'integrations'

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      style={{ minHeight: '60vh', backgroundColor: `${colors.white}` }}
    >
      <Box style={{ width: '350px' }} maxWidth="small" marginY="xxxlarge">
        <Stack align="center" space="large">
          <EmptyImage
            alt={text || t('b.contract.view.nothing_here.text', 'Nothing here for now...')}
          />
          <Stack align="center" space="medium">
            <Stack align="center" space="xsmall">
              <Text size="medium" weight="medium">
                {isIntegration
                  ? t(
                      'l.listings.empty_integration_listings.title',
                      'Import your listings from other platforms'
                    )
                  : t('l.listings.empty_listings.title', 'Discover an easier way to rent')}
              </Text>
              <Text align="center" size="small" tone="secondary">
                {isIntegration
                  ? t(
                      'l.listings.empty_integration_listings.text',
                      'Get in touch with our team for a custom solution.'
                    )
                  : t(
                      'l.listings.empty_listings.text',
                      "Publish your listing to start saving time with liv.rent's rental management tools."
                    )}
              </Text>
            </Stack>
            {isIntegration ? (
              <Text tone="link" size="medium">
                <TextLink href="mailto:support@liv.rent" weight="regular">
                  {t('l.listings.empty_integration_listings.contact_us', 'Contact us')}
                </TextLink>
              </Text>
            ) : (
              <Text tone="link" size="medium">
                <TextLink href={`${APP_PATH}/listing/create`} weight="regular">
                  {t('l.listings.empty_listings.create_listing', 'Create a listing')}
                </TextLink>
              </Text>
            )}
          </Stack>
        </Stack>
      </Box>
    </Box>
  )
}

export default ListingsEmptyListComponent
